import { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getContexts } from 'constants/contexts';
import { ServiceContext } from 'providers/ServiceProvider';
const availableContexts = getContexts();

const ContextRetriever = ({ match, history }) => {
  const serviceRoute = match.params.serviceRoute;
  const [, setActiveService] = useContext(ServiceContext);

  const contextChangeEffect = () => {
    const serviceExist = availableContexts.some(x => x.serviceRoute === serviceRoute.toLowerCase());
    if (serviceRoute && serviceExist) {
      const context = availableContexts.find(x => x.serviceRoute === serviceRoute.toLowerCase());
      setActiveService({ displayName: context.displayName, route: context.serviceRoute });
    }
    history.push('/');
  };

  useEffect(contextChangeEffect, [serviceRoute, history, setActiveService]);

  return '';
};

ContextRetriever.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default withRouter(ContextRetriever);
